import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { ClinicCard } from '../../../Components/ui/ClinicCard/ClinicCard';
import { clinicDoctors, clinicSpecialties } from '../../../data/onlineClinics';
import './onlineclinics.css';

export const Onlineclinics = () => {
  const [activeTab, setActiveTab] = useState(clinicSpecialties[0]);

  return (
    <section className="online-clinics">
      <Container fluid>

        {/* Heading */}
        <h2 className="online-clinics__title">Online Clinics</h2>
        <p className="online-clinics__subtitle">
          Learn from leading doctors and specialists through focused, digestible video content.
        </p>

        {/* Tabs + City selector row */}
        <div className="online-clinics__controls">
          <div className="online-clinics__tabs-wrap">
            <div className="online-clinics__tabs">
              {clinicSpecialties.map((s) => (
                <button
                  key={s}
                  className={`online-clinics__tab ${activeTab === s ? 'online-clinics__tab--active' : ''}`}
                  onClick={() => setActiveTab(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* City dropdown */}
          <div className="online-clinics__city-select">
            <svg className="online-clinics__city-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <span>Select City</span>
            <svg className="online-clinics__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
        </div>

        {/* Cards — horizontally scrollable */}
        <div className="online-clinics__scroll-wrap">
          <div className="online-clinics__track">
            {clinicDoctors.map((doc) => (
              <div key={doc.id} className="online-clinics__card-item">
                <ClinicCard {...doc} />
              </div>
            ))}
          </div>
        </div>

      </Container>
    </section>
  );
};
